import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import Typed from 'typed.js';
import './Hero.css';
import CodeBackground from '../CodeBackground/CodeBackground';

const Hero = () => {
  const el = useRef(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const typedRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    if (typedRef.current) {
      typedRef.current.destroy();
    }

    const typed = new Typed(el.current, {
      strings: [
        t('titles.backendDev'),
        t('titles.fullstackDev'),
        t('titles.techExplorer'),
        t('titles.npmCreator'),
        t('titles.techResearcher'),
        t('titles.aiEnthusiast'),
        t('titles.innovationEng'),
        t('titles.dbEngineer'),
        t('titles.solutionBuilder'),
        t('titles.osContributor')
      ],
      typeSpeed: 100,
      backSpeed: 100,
      showCursor: false,
      loop: true,
      onBegin: () => {
        setIsLoading(false);
      }
    });

    typedRef.current = typed;
  }, [t, i18n.language]);

  return (
    <section id="home" className="hero">
      <div className={`hero-content ${isLoading ? 'loading' : ''}`} 
        style={{
          transform: `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)`
        }}>
        <div className="hero-left">
          <h1 className="hero-title">
            <span className="greeting-text">{t('greetings')}</span>
            <span className="gradient-text">{t('name')}</span>
          </h1>
          
          <div className="typed-container">
            <span className="focus-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('focusedOn')) }} />
            <span ref={el} className="typed-text"></span>
          </div>

          <div className="connect-section">
            <h3 className="connect-text">Let's Connect</h3>
            <div className="social-links">
              <a 
                href="https://github.com/suresh2291" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label={t('accessibility.githubProfile')}
              >
                <i className="fab fa-github"></i>
              </a>
              <a 
                href="https://www.linkedin.com/in/amrutham-suresh-kumar-43813b111/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label={t('accessibility.linkedinProfile')}
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="profile-image">
            <img src="/mypic.png" alt="Profile" />
          </div>
        </div>
      </div>
      <CodeBackground />
    </section>
  );
};

export default Hero;
